<div class="parent">
    <div class="admin-login-card text-center p-3 bg-white">
      <div class="logo my-2 text-center">
        <img src="../../assets/Images/ecademic-logo.jpg" alt="" style="height: 100px; width: 80px;">
      </div>
      <h4 class="mb-4">Admin Login</h4>
      <div class="input-group input-group-lg mb-3">
        <input type="email" class="form-control" placeholder="Enter email*" [(ngModel)]="adminEmail">
      </div>
      <div class="input-group input-group-lg mb-3">
        <input type="password" class="form-control" placeholder="Enter password*" [(ngModel)]="adminPassword">
      </div>
      <div *ngIf="invalidCredentialsError" class="alert alert-danger" role="alert">
        Invalid Credentials!
      </div>
      <hr>
      <button type="button" class="btn btn-block btn-primary" (click)="onAdminLogin()">Login</button>
      <button type="button" class="btn btn-block btn-outline-danger" routerLink="/">Back to Homepage</button>
    </div>
  </div>
